module.exports = __webpack_public_path__ + "img/2-1.13aff8d0.png";